<template>
    <div class="d-flex flex-column align-items-baseline edit-title-form">
        <p class="edit-title">Add event time</p>
        <div class="timepicker">
            <div>
                <p class="time-edit-field">Start Time*</p>
                <div
                    class="d-flex align-items-center edit-form-control-field position-relative"
                >
                    <div @click="timeSelector.handleShowStartTime" class="time-field">
                        <p class="event-time">
                            {{ timeSelector.startTime.value }}
                            {{ timeSelector.timeFormat.value }}
                        </p>
                        <img
                            :src="getIcon() + 'timepicker-icon.png'"
                            :class="{ 'rotate-arrow': timeSelector.showStartTime.value }"
                        />
                    </div>
                    <div v-if="timeSelector.showStartTime.value" class="select-time">
                        <div class="time-format-container">
                            <p
                                class="time-format"
                                :class="{
                                    'selected-time-format': timeSelector.selectTimeFormat.value
                                }"
                                @click="timeSelector.changeTimeFormat"
                            >
                                AM
                            </p>
                            <p
                                class="time-format"
                                :class="{
                                    'selected-time-format':
                                        !timeSelector.selectTimeFormat.value
                                }"
                                @click="timeSelector.changeTimeFormat"
                            >
                                PM
                            </p>
                        </div>
                        <div class="divider"></div>
                        <div class="time-count">
                            <p
                                @click="timeSelector.setTime(time)"
                                class="time"
                                v-for="(time, index) in timeSelector.timeList.value"
                                :key="index"
                            >
                                {{ time }} <span>{{ timeSelector.timeFormat.value }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="end-time">
                <p class="time-edit-field">End Time</p>
                <div
                    class="d-flex align-items-center edit-form-control-field position-relative"
                >
                    <div @click="timeSelector.handleShowEndTime" class="time-field">
                        <p class="event-time">
                            {{ timeSelector.endTime.value }}
                            {{ timeSelector.timeFormatEnd.value }}
                        </p>
                        <img
                            :src="getIcon() + 'timepicker-icon.png'"
                            :class="{ 'rotate-arrow': timeSelector.showEndTime.value }"
                        />
                    </div>
                    <div v-if="timeSelector.showEndTime.value" class="select-time">
                        <div class="time-format-container">
                            <p
                                class="time-format"
                                :class="{
                                    'selected-time-format':
                                        timeSelector.selectTimeFormatEnd.value
                                }"
                                @click="timeSelector.changeEndTimeFormat"
                            >
                                AM
                            </p>
                            <p
                                class="time-format"
                                :class="{
                                    'selected-time-format':
                                        !timeSelector.selectTimeFormatEnd.value
                                }"
                                @click="timeSelector.changeEndTimeFormat"
                            >
                                PM
                            </p>
                        </div>
                        <div class="divider"></div>
                        <div class="time-count">
                            <p
                                @click="timeSelector.setEndTime(time)"
                                class="time"
                                v-for="(time, index) in timeSelector.timeListEnd.value"
                                :key="index"
                            >
                                {{ time }} <span>{{ timeSelector.timeFormatEnd.value }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="end-time">
                <p class="time-edit-field">Duration</p>
                <input
                    class="edit-form-control-field"
                    style="min-height: 51px; background-color: #262626; max-width: 150px"
                    type="text"
                    disabled
                    v-model="duration"
                />
            </div>
        </div>
        <button class="save-title-btn" @click="updateEventTime">Save</button>
    </div>
</template>

<script>
    import moment from 'moment'
    import axios from 'axios'
    import { notification } from '@/helpers/notification'
    import useTimeSelector from '@/composables/useTimeSelector.js'

    export default {
        name: 'AddEventTime',
        props: {
            eventData: {
                type: Object
            }
        },
        data: () => ({
            duration: ''
        }),
        methods: {
            getIcon() {
                return '/images/'
            },
            async updateEventTime() {
                try {
                    const response = await axios.put(
                        '/event/manage/update/' + this.eventData.id,
                        {
                            start: this.eventData.start.includes('T')
                                ? this.eventData.start.split('T')[0]
                                : this.eventData.start.split(' ')[0],
                            start_time: `${this.timeSelector.startTime.value} ${this.timeSelector.timeFormat.value}`,
                            end: `${this.timeSelector.endTime.value} ${this.timeSelector.timeFormatEnd.value}`,
                            duration: this.duration,
                            recurring: this.eventData.recurring,
                            event_name: this.eventData.event_name
                        }
                    )
                    notification('success', 'Event time successfully updated')
                    if (response.status === 200) {
                        const newEventData = {
                            id: this.eventData.id,
                            end: this.timeSelector.endTime.value,
                            start_time: response.data.data.start_time,
                            duration: this.duration
                        }

                        this.$emit('updateEventData', newEventData)
                    }
                } catch (err) {
                    this.serverErrMsg = `[${err.response?.status}] : ${err.response?.data?.message}`
                }
            },
            getEventStartTime(event) {
                if (event.start_time) {
                    this.timeSelector.startTime.value = event.start_time.split(' ')[0]
                    this.timeSelector.timeFormat.value = event.start_time.split(' ')[1]
                } else {
                    const parsedTime = moment.utc(event.start)
                    this.timeSelector.startTime.value = parsedTime.format('h:mm')
                    this.timeSelector.timeFormat.value = parsedTime.format('A')
                }
            }
        },
        watch: {
            duration: function (duration) {
                if (duration) {
                    ;[this.timeSelector.endTime.value, this.timeSelector.timeFormatEnd.value] =
                        this.timeSelector.calculateEndTime(duration)
                } else {
                    this.timeSelector.resetSetTimeAndDuration()
                }
            },
            'timeSelector.startTime.value': function () {
                this.duration = this.timeSelector.calculateDuration()
            },
            'timeSelector.endTime.value': function () {
                this.duration = this.timeSelector.calculateDuration()
            }
        },
        setup() {
            const {
                timeList,
                timeListEnd,
                startTime,
                endTime,
                timeFormat,
                timeFormatEnd,
                showStartTime,
                showEndTime,
                selectTimeFormat,
                selectTimeFormatEnd,
                resetSetTimeAndDuration,
                calculateDuration,
                calculateEndTime,
                changeTimeFormat,
                changeEndTimeFormat,
                setTime,
                setEndTime,
                handleShowStartTime,
                handleShowEndTime
            } = useTimeSelector()

            return {
                timeSelector: {
                    timeList,
                    timeListEnd,
                    startTime,
                    endTime,
                    timeFormat,
                    timeFormatEnd,
                    showStartTime,
                    showEndTime,
                    selectTimeFormat,
                    selectTimeFormatEnd,
                    resetSetTimeAndDuration,
                    calculateDuration,
                    calculateEndTime,
                    changeTimeFormat,
                    changeEndTimeFormat,
                    setTime,
                    setEndTime,
                    handleShowStartTime,
                    handleShowEndTime
                }
            }
        },
        created() {
            this.getEventStartTime(this.eventData)
            this.duration = this.eventData.duration
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .divider {
        height: 1px;
        width: 100%;
        background: #8b8b8b;
    }
    .time-field {
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
    }
    .timepicker {
        display: flex;
        align-items: center;
        gap: 25px;
    }
    .time-count::-webkit-scrollbar {
        width: 8px;
    }
    .time-count::-webkit-scrollbar-track {
        background-color: none;
    }
    .time-count::-webkit-scrollbar-thumb {
        max-height: 64px;
        border-radius: 8px;
        background: #8b8b8b;
    }
    .time-count {
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
        gap: 8px;
    }
    .time {
        color: #dedede;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        cursor: pointer;
        margin: 0;
    }
    .time span {
        color: #8b8b8b;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .select-time {
        z-index: 1;
        position: absolute;
        padding: 8px 8px 12px 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        border-radius: 12px;
        background: #333;
        box-shadow: 0 6px 12px -4px rgba(0, 0, 0, 0.5);
        top: 50px;
        left: 0;
        max-height: 200px;
        min-width: 150px;
    }
    .rotate-arrow {
        transform: rotate(180deg);
    }
    .select-time::-webkit-scrollbar {
        display: none;
    }
    .time-format-container {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
    }
    .time-format {
        display: flex;
        padding: 4px 8px;
        justify-content: center;
        align-items: center;
        flex: 1 0 0;
        border-radius: 6px;
        margin: 0;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        color: #8b8b8b;
        cursor: pointer;
    }
    .selected-time-format {
        background: #cdeb09;
        color: #121212;
    }
    .event-time {
        color: #646464;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        margin: 0;
    }
    .time-edit-field {
        color: #fff;
        font-family: 'Instrument Sans';
        margin: 0;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .edit-title {
        color: #dedede;
        font-feature-settings: 'dlig' on, 'ss05' on, 'ss10' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .edit-form-control-field {
        display: flex;
        padding: 12px 12px 16px 16px;
        align-items: center;
        gap: 12px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        color: #646464;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
    .save-title-btn {
        display: inline-flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        text-align: center;
        letter-spacing: 1.8px;
        text-transform: uppercase;
        border: 0;
        width: 100%;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .edit-title-form {
        gap: 34px;
    }
    @media (max-width: 600px) {
        .timepicker {
            flex-direction: column;
        }
    }
</style>
